import { render } from "./account-details.vue?vue&type=template&id=9f088e6a&scoped=true&ts=true"
import script from "./account-details.vue?vue&type=script&lang=ts"
export * from "./account-details.vue?vue&type=script&lang=ts"

import "./account-details.vue?vue&type=style&index=0&id=9f088e6a&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f088e6a"]])

export default __exports__